import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PeopleIcon from '@mui/icons-material/People';
import { useNavigate } from 'react-router-dom';
import {
  bool, number, oneOfType, string,
} from 'prop-types';
import RowLayout from '../../layouts/rows';
import ColumnLayout from '../../layouts/column';
import IsAdminTagComponent from '../tags/isAdmin';
import { GroupDetailsPathBuilder } from '../../constants/routes.contants';

function GroupListItemComponent({
  id, name, numMembers, isAdmin,
}) {
  const navigate = useNavigate();

  const onClick = () => {
    navigate(GroupDetailsPathBuilder(id));
  };
  return (
    <Box
      border="1px solid black"
      borderRadius="5px"
      width="80%"
      maxWidth="353px"
      p="10px"
    >
      <RowLayout justifyContent="space-between" overflow="flex">
        <ColumnLayout overflow="flex" alignItems="flex-start">
          <Typography variant="h5">{name}</Typography>
          <Box display="flex" flexDirection="row" width="35px" justifyContent="space-between">
            <PeopleIcon />
            <Typography variant="subtitle1">{numMembers}</Typography>
          </Box>
          {isAdmin && <IsAdminTagComponent />}
        </ColumnLayout>
        <IconButton onClick={onClick}>
          <ChevronRightIcon />
        </IconButton>
      </RowLayout>
    </Box>
  );
}

GroupListItemComponent.propTypes = {
  id: oneOfType([string, number]).isRequired,
  name: string.isRequired,
  numMembers: number.isRequired,
  isAdmin: bool,
};

GroupListItemComponent.defaultProps = {
  isAdmin: false,
};

export default GroupListItemComponent;
